import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import categoriesModel from "venuescanner-js/react/components/VirtualEvents/models/categories";

const CategorySwitcher = (props) => {
  const { activeCategory, setActiveCategory } = props;
  const [isOpen, setIsOpen] = useState(isOpen);
  const links = categoriesModel.map((category, index) =>
    category.name !== activeCategory.name ? (
      <NavLink
        key={category.name + index}
        style={{ transitionDelay: `calc(15ms * ${index})` }}
        className="virtual-events-category-switcher__link"
        onClick={() => setIsOpen(!isOpen)}
        to={{ pathname: `/virtual-events/${category.slug}` }}
      >
        <span>{category.name}</span>
      </NavLink>
    ) : null
  );
  return (
    <div
      className={`virtual-events-category-switcher ${
        isOpen ? "isOpen" : "isClosed"
      }`}
    >
      <span
        className="virtual-events-category-switcher__link"
        onClick={() => setIsOpen(!isOpen)}
      >
        Change Category
      </span>
      {links}
    </div>
  );
};

export default CategorySwitcher;
